module.exports = __webpack_public_path__ + "img/images.50b815f7.png";